module.exports = __webpack_public_path__ + "media/marketplace_fund/deck-preview-5-f9b87dc4.jpg";